import { type Store } from 'src/old/reducers/dataChangeRequests/types';

export const selectDataChangeRequests = (store: Store) => store?.dataChangeRequests?.employeesRequestedDataChange;
